export default{
    methods:{
        absoluteUrl(path = ""){
            return this.$store.state.domain + path
        },
        calculateDeliveryTime(time){
            return time > 72
               ?  `${time/24} Days`
               : `${time} Hrs`
        },
        isImageFile(ext){
            return  ['png','jpeg','svg','jpg','webp'].includes(ext ? ext.toLowerCase() : null)
        },
        preText(content) {
            if(!content) return;
            return content.replace(/\n/g, '<br />')
        },
        scrollToView(elID){
            if(!elID){return}
            const yOffset = -200;
            const element = document.getElementById(elID);
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        },
        alertSuccess(text){
            toastr.success(text, 'Success');
        },
        alertError(text){
            toastr.error(text, 'Something went worry', {timeOut: 3000});
        },
    }
}
